<template>
	<div class="filterPage" @click.self="closeFilters">
		<transition name="allFiltersMod">
			<div
				@click.self="allFilters"
				v-if="allFiltersOpen"
				class="allFiltersModal"
			>
				<div class="allFiltersModal__right stickyFilter">
					<div @click="allFilters" class="stickyFilter__top">
						<p>Filters</p>
						<CloseFilter></CloseFilter>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openCategories"
							:class="[
								categoryFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Category</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								categoryFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in categories"
									:key="index"
								>
									<label class="listFilter__label" :for="item.slug"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.slug"
											:value="item.slug"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openMiniseries"
							:class="[
								miniseriesFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Miniseries</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								miniseriesFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in miniseries"
									:key="index"
								>
									<label class="listFilter__label" :for="item.slug"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.slug"
											:value="item.slug"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="stickyFilter__category">
						<div
							@click.self="openEpisodeLengths"
							:class="[
								episodeLengthFilterOpen
									? 'stickyFilter__categoryTop stickyFilter__categoryTop--open'
									: 'stickyFilter__categoryTop',
							]"
						>
							<p>Episode Length</p>
							<FilterCaret></FilterCaret>
						</div>
						<div
							:class="[
								episodeLengthFilterOpen
									? 'stickyFilter__list stickyFilter__list--open'
									: 'stickyFilter__list',
							]"
						>
							<div>
								<div
									class="listFilter"
									v-for="(item, index) in episodeLengths"
									:key="index"
								>
									<label class="listFilter__label" :for="item.slug"
										>{{ item.title }}
										<input
											class="listFilter__cb"
											type="checkbox"
											:id="item.slug"
											:value="item.slug"
											v-model="checkedCategories"
										/>
										<span class="listFilter__displayBox"></span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<div class="filterPage__top">
			<div class="filterPage__leftTop">
				<div class="filterPage__wrapper">
					<div v-if="windowWidth > 768" class="filterPage__container">
						<div
							@click.self="openCategories"
							:class="[
								categoryFilterOpen
									? 'filterPage__filter filterPage__filter--open'
									: 'filterPage__filter',
							]"
						>
							<p @click.self="openCategories">Category</p>
							<FilterCaret></FilterCaret>
							<div v-if="categoryFilterOpen" class="filterPage__listCont">
								<div @click="openCategories" class="filterPage__closeFilter">
									<CloseFilter></CloseFilter>
								</div>
								<ul class="filterPage__list listFilter">
									<li
										class="listFilter__li"
										v-for="(item, index) in categories"
										:key="index"
									>
										<label class="listFilter__label" :for="item.slug"
											>{{ item.title }}
											<input
												class="listFilter__cb"
												type="checkbox"
												:id="item.slug"
												:value="item.slug"
												v-model="checkedCategories"
											/>
											<span class="listFilter__displayBox"></span>
										</label>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div v-if="windowWidth > 768" class="filterPage__container">
						<div
							@click.self="openMiniseries"
							:class="[
								miniseriesFilterOpen
									? 'filterPage__filter filterPage__filter--open'
									: 'filterPage__filter',
							]"
						>
							<p @click.self="openMiniseries">Miniseries</p>
							<FilterCaret></FilterCaret>
							<div v-if="miniseriesFilterOpen" class="filterPage__listCont">
								<div @click="openMiniseries" class="filterPage__closeFilter">
									<CloseFilter></CloseFilter>
								</div>
								<ul class="filterPage__list listFilter">
									<li
										class="listFilter__li"
										v-for="(item, index) in miniseries"
										:key="index"
									>
										<label class="listFilter__label" :for="item.slug"
											>{{ item.title }}
											<input
												class="listFilter__cb"
												type="checkbox"
												:id="item.slug"
												:value="item.slug"
												v-model="checkedCategories"
											/>
											<span class="listFilter__displayBox"></span>
										</label>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div v-if="windowWidth > 768" class="filterPage__container">
						<div
							@click.self="openEpisodeLengths"
							:class="[
								episodeLengthFilterOpen
									? 'filterPage__filter filterPage__filter--open'
									: 'filterPage__filter',
							]"
						>
							<p @click.self="openEpisodeLengths">Episode Length</p>
							<FilterCaret></FilterCaret>
							<div v-if="episodeLengthFilterOpen" class="filterPage__listCont">
								<div
									@click="openEpisodeLengths"
									class="filterPage__closeFilter"
								>
									<CloseFilter></CloseFilter>
								</div>
								<ul class="filterPage__list listFilter">
									<li
										class="listFilter__li"
										v-for="(item, index) in episodeLengths"
										:key="index"
									>
										<label class="listFilter__label" :for="item.value"
											>{{ item.title }}
											<input
												class="listFilter__cb"
												type="checkbox"
												:id="item.slug"
												:value="item.slug"
												v-model="checkedCategories"
											/>
											<span class="listFilter__displayBox"></span>
										</label>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div
						@click="allFilters"
						:class="[
							allFiltersOpen
								? 'filterPage__filter filterPage__filter--open'
								: 'filterPage__filter',
						]"
					>
						<p>All filters</p>
						<img src="/lib/img/filters.png" alt="All Filters" />
					</div>
					<div
						@click="clearFilters"
						v-if="checkedCategories.length > 0"
						class="filterPage__clearFilter"
					>
						<p>Clear Filters</p>
					</div>
				</div>
			</div>
		</div>
		<div class="filterPage__middleCont">
			<div v-if="checkedCategories.length > 0" class="filterPage__middle">
				<li
					v-if="checkedCategories.includes(item.slug)"
					class="listFilter__li"
					v-for="(item, index) in mergedFilters"
					:key="index"
				>
					<label class="listFilter__label" :for="item.slug"
						>{{ item.title }}
						<input
							class="listFilter__cb"
							type="checkbox"
							:id="item.slug"
							:value="item.slug"
							v-model="checkedCategories"
						/>
						<RemoveX></RemoveX>
					</label>
				</li>
			</div>
		</div>
		<div class="filterPage__bottom">
			<div
				class="filterPage__noBlogs"
				v-if="dataRendered.length === 0 && noEventsForCategoryText !== ''"
			>
				<h2>
					Unfortunately, there are no Pemcasts at this time for "{{
						noEventsForCategoryText
					}}"
				</h2>
			</div>
			<div class="filterPage__bottomWrapper">
				<div
					@click="openCategories"
					v-if="
						categoryFilterOpen ||
						miniseriesFilterOpen ||
						episodeLengthFilterOpen
					"
					class="filterPage__bottomOverlay"
				></div>
				<div
					v-for="(item, index) in dataRendered"
					:key="index"
					class="filterPage__gridItem gridItem redactorStyles"
				>
					<a tabindex="0" :href="item.data.url">
						<div class="gridItem__imgCont">
							<img v-if="item.image" :src="item.image" :alt="item.data.title" />
						</div>
					</a>
					<h4 class="gridItem__title">{{ item.data.title }}</h4>
					<p v-if="item.data.description" class="gridItem__p">
						{{ item.data.description }}
					</p>
					<p v-if="item.data.readTime" class="gridItem__readTime">
						{{ item.data.readTime }}
					</p>
					<div class="gridItem__buttons buttons">
						<div class="prmBtn prmBtn--darkOutline">
							<a tabindex="0" :href="item.data.url">
								<p>Read now</p>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="total > count"
				@click="getMoreElements"
				class="filterPage__getMore"
			>
				<div class="filterPage__getMoreButton">
					<p>Show More</p>
					<ShowMore></ShowMore>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import CloseFilter from './svg/CloseFilter';
import FilterCaret from './svg/FilterCaret';
import RemoveX from './svg/RemoveX';
import ShowMore from './svg/ShowMore';
import { gsap } from 'gsap';

export default {
	name: 'BlogFilter',
	props: {
		// categoryTitles: Object,
	},
	components: {
		multiselect: Multiselect,
		CloseFilter,
		FilterCaret,
		RemoveX,
		ShowMore,
	},
	data() {
		return {
			dataRendered: [],
			checkedCategories: [],
			categories: [],
			miniseries: [],
			mergedFilters: [],
			episodeLengths: [],
			categoryFilterOpen: false,
			miniseriesFilterOpen: false,
			episodeLengthFilterOpen: false,
			allFiltersOpen: false,
			windowWidth: null,
			noEventsForCategoryText: '',
			perPage: 12,
			newUrl: null,
			total: null,
			count: null,
		};
	},
	beforeMount() {
		this.getSearch();
		this.getFilters();
	},

	mounted() {
		this.getData();
		this.window();
		let that = this;
		jQuery(document).ready(function ($) {
			$(window).resize(function () {
				that.window();
			});
		});
	},
	methods: {
		window() {
			let winWidth = $(window).width();
			this.windowWidth = winWidth;
		},
		getFilters() {
			this.getCategories();
			this.getMiniseries();
			this.getEpisodeLengths();
		},
		clearFilters() {
			this.checkedCategories = [];
		},
		getData() {
			let categoriesString = this.checkedCategories.toString();
			let that = this;
			$.get(
				'/api/v1/pemcasts',
				{
					categories: categoriesString,
					perPage: that.perPage,
				},
				function (res) {
					that.dataRendered = res.data;
					that.total = res.meta.pagination.total;
					that.count = res.meta.pagination.count;
				}
			);
		},
		getCategories() {
			let that = this;
			$.get('/api/v1/categories', function (res) {
				res.data.forEach((el) => {
					that.categories.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		getMiniseries() {
			let that = this;
			$.get('/api/v1/miniseries', function (res) {
				res.data.forEach((el) => {
					that.miniseries.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		getEpisodeLengths() {
			let that = this;
			$.get('/api/v1/episodeLengths', function (res) {
				res.data.forEach((el) => {
					that.episodeLengths.push({
						title: el.item.title,
						id: el.item.id,
						slug: el.item.slug,
					});
				});
			});
		},
		openCategories() {
			this.miniseriesFilterOpen = false;
			this.episodeLengthFilterOpen = false;
			this.categoryFilterOpen = !this.categoryFilterOpen;
		},
		openMiniseries() {
			this.categoryFilterOpen = false;
			this.episodeLengthFilterOpen = false;
			this.miniseriesFilterOpen = !this.miniseriesFilterOpen;
		},
		openEpisodeLengths() {
			this.miniseriesFilterOpen = false;
			this.categoryFilterOpen = false;
			this.episodeLengthFilterOpen = !this.episodeLengthFilterOpen;
		},
		allFilters() {
			this.categoryFilterOpen = false;
			this.miniseriesFilterOpen = false;
			this.episodeLengthFilterOpen = false;
			this.allFiltersOpen = !this.allFiltersOpen;
		},
		closeFilters() {
			this.categoryFilterOpen = false;
			this.miniseriesFilterOpen = false;
			this.episodeLengthFilterOpen = false;
		},
		getSearch() {
			let search = window.location.search;
			let url = new URLSearchParams(search);
			if (url.size === 0) {
				return;
			}
			let category = url.get('category').split(',');
			this.checkedCategories = category;
		},
		getMoreElements() {
			this.perPage += 12;
		},
		mergeAll() {
			this.mergedFilters = this.categories.concat(
				this.miniseries,
				this.episodeLengths
			);
		},
	},
	watch: {
		categories() {
			this.mergeAll();
		},
		miniseries() {
			this.mergeAll();
		},
		episodeLengths() {
			this.mergeAll();
		},
		checkedCategories() {
			let currentUrl = window.location.search;
			let currentParams = new URLSearchParams(currentUrl.search);
			let arrayToString = this.checkedCategories.toString();
			if (this.checkedCategories.length === 0) {
				currentParams.delete('category');
				let newUrl = window.location.pathname;
				newUrl = decodeURIComponent(newUrl);
				history.pushState(null, '', newUrl);
				if (this.perPage !== 12) {
					this.perPage = 12;
				}
				this.newUrl = newUrl;
				this.noEventsForCategoryText = '';
			} else {
				currentParams.set('category', arrayToString);
				let newUrl = window.location.pathname + '?' + currentParams;
				newUrl = decodeURIComponent(newUrl);
				history.pushState(null, '', newUrl);
				if (this.perPage !== 12) {
					this.perPage = 12;
				}
				this.newUrl = newUrl;
				let textForCategory = this.checkedCategories
					.join(', ')
					.replaceAll('-', ' ');
				this.noEventsForCategoryText = textForCategory;
			}
		},
		perPage() {
			this.getData();
		},
		newUrl() {
			this.getData();
		},
	},
};
</script>
